import { translate as t } from '@thoughtspot/i18n';
import { Table } from '@thoughtspot/radiant-react/widgets/table';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { Horizontal, Vertical } from "../../../../utils/layouts";
import { dataColumnsClusterLogs, prepareClusterLogsData, } from '../cluster-status-utils';
import styles from './cluster-logs-tables.module.scss';
export const ClusterLogsTable = ({ statsData, }) => {
    const logData = prepareClusterLogsData(statsData);
    const renderContent = () => (React.createElement(Vertical, { className: styles.table, "data-testid": "cluster-logs-table-id" },
        React.createElement(Typography, { variant: "h4", color: Colors.base, noMargin: true }, t('adminUI.messages.CLUSTER_DETAIL_LOG_TITLE')),
        React.createElement(Table, { className: styles.tableComponent, data: logData, columns: dataColumnsClusterLogs }),
        logData && (React.createElement(Horizontal, { className: styles.tableFooter },
            React.createElement(Typography, { variant: "body-normal", color: Colors.base, noMargin: true }, t('pagination_footer', {
                total: logData.length,
            }))))));
    return renderContent();
};
//# sourceMappingURL=cluster-logs.container.js.map